import { useEffect, useState } from "react";
import { FaHeart, FaRegHeart, FaReply, FaLock } from "react-icons/fa";
import { AiOutlineLoading } from "react-icons/ai";
import { getDashboardData, giveReaction, giveComment } from "../../../api/Capsule.api";
import { requestOpenCapsule } from "../../../api/Capsule.api";
import "./style.scss";
import { useParams } from "react-router-dom";

const Dashboard = () => {
  const [dashboardItems, setDashboardItems] = useState([]); // To store capsules and ads
  const [likedCapsules, setLikedCapsules] = useState({}); // To manage liked capsules
  const [replies, setReplies] = useState({}); // To manage replies for posts
  const [loading, setLoading] = useState(true); // Loading state
  const [error, setError] = useState(null); // Error state
  const [selectedImage, setSelectedImage] = useState(null);
  const { mode = "all" } = useParams();
  // Fetch dashboard data on component mount
  useEffect(() => {
    const fetchDashboardData = async () => {
      try {
        setLoading(true);

        let statusFilter = undefined;
        if (mode === "posted") statusFilter = "Opened";
        else if (mode === "pending") statusFilter = "Locked";
        const data = await getDashboardData(1, 10, statusFilter); // Fetch page 1 with 10 items
        setDashboardItems(data.data); // Set the fetched data
      } catch (err) {
        setError("Sign in to view your dashboard.");
        console.error(err);
      } finally {
        setLoading(false);
      }
    };

    fetchDashboardData();
  }, [mode]);

  const handleLike = async (postId, reactionType = "Heart") => {
    try {
      const response = await giveReaction(postId, reactionType); // Call the API
      console.log(`${reactionType} reaction response:`, response);
      setLikedCapsules((prev) => ({
        ...prev,
        [postId]: !prev[postId], // toggle trạng thái
      }));
    } catch (error) {
      console.error(`Error reacting with "${reactionType}" to post:`, error);
      alert(`Failed to react with "${reactionType}". Please try again.`);
    }
  };

  const handleReply = async (postId) => {
    if (!replies[postId]?.trim()) return; // Ensure the reply is not empty

    try {
      const commentText = replies[postId]; // Get the reply text
      const response = await giveComment(postId, commentText); // Call the API
      console.log("Reply response:", response);
      alert("Your comment has been posted!");
      setReplies((prev) => ({ ...prev, [postId]: "" })); // Clear the reply input
    } catch (error) {
      console.error("Error posting reply:", error);
      alert("Failed to post your comment. Please try again.");
    }
  };

  const handleOpenCapsule = async (capsuleId) => {
    try {
      const response = await requestOpenCapsule(capsuleId);
      console.log("Capsule opened successfully:", response);
      // Optionally update the UI or fetch updated data
      alert("Capsule opened successfully!");
    } catch (error) {
      console.error("Failed to open capsule:", error);
      alert("Failed to open capsule. Please try again.");
    }
  };

  if (loading) return <div className="loading-wrapper"><AiOutlineLoading className="loading-icon" /></div>;
  if (error) return <div>{error}</div>;


  return (
    <div className="post-list">
      {dashboardItems.map((item, index) => {
        if (item.type === "capsule") {
          const capsule = item.data;
          const now = new Date();
          const openingTime = new Date(capsule.openingTime);

          return (
            <div
              className={`post-item ${capsule.status === "Locked" ? "locked" : ""}`}
              key={capsule.id}
            >
              <div className="post-header">
                <img
                  src={capsule.imageUrl || "public/default-avatar.jpeg"}
                  alt="avatar"
                  className="avatar"
                />
                <div>
                  <strong>{capsule.theme}</strong>
                  <div className="time">
                    {new Date(capsule.createdAt).toLocaleString()}
                  </div>
                </div>
              </div>

              {capsule.status === "Locked" ? (
                <>
                  <p className="post-description">{capsule.description}</p>
                  <div className="locked-overlay">
                    <FaLock />
                    <p>This capsule is locked.</p>
                  </div>
                </>
              ) : (
                <>
                  <p className="post-content">{capsule.content}</p>
                  <div className="post-media">
                    {capsule.capsulemedia && capsule.capsulemedia.length > 0 ? (
                      <div className="media-gallery">
                        {capsule.capsulemedia?.map((media) => (
                          console.log("Media URL:", media),
                          <img
                            src={media.mediaUrl}
                            alt={`media`}
                            className="media-item"
                            onClick={() => setSelectedImage(media.mediaUrl)}
                          />
                        ))}
                      </div>
                    ) : (
                      <p>No media available for this capsule.</p>
                    )}
                  </div>
                  {selectedImage && (
                    <div className="image-modal" onClick={() => setSelectedImage(null)}>
                      <img src={selectedImage} alt="full size" />
                    </div>
                  )}

                  <div className="post-actions">
                    <button onClick={() => handleLike(capsule.id)}>
                      {likedCapsules[capsule.id] ? (
                        <FaHeart color="red" />
                      ) : (
                        <FaRegHeart />
                      )}
                    </button>
                  </div>

                  <div className="post-reply">
                    <input
                      type="text"
                      placeholder="Write a reply..."
                      value={replies[capsule.id] || ""}
                      onChange={(e) =>
                        setReplies((prev) => ({
                          ...prev,
                          [capsule.id]: e.target.value,
                        }))
                      }
                    />
                    <button onClick={() => handleReply(capsule.id)} disabled={!replies[capsule.id]?.trim()}>
                      <FaReply />
                    </button>
                  </div>
                </>
              )}
            </div>
          );
        } else if (item.type === "ad") {
          const ad = item.data;
          return (
            <div className="ad-item" key={ad.adId}>
              <a href={ad.targetUrl} target="_blank" rel="noopener noreferrer">
                <img src={`/${ad.mediaUrl}`} alt={ad.title} />
                <h3>{ad.title}</h3>
              </a>
            </div>
          );
        }
        return null;
      })}
    </div>
  );
};

export default Dashboard;